module.exports = __webpack_public_path__ + "static/AW_women-8af30d7439fdf2ef3c1e60f8549f7390.jpg";